// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { koi as _koi } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the koi chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 701
 * Chain Name: Koi Network
 * Default Block Explorer: https://koi-scan.darwinia.network
 * Default RPC URL: https://koi-rpc.darwinia.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { koi } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: koi,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const koi = createCommon({
	..._koi,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
